import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';
import Typography from '../Atoms/Typography.js';
import Divider from '../Atoms/Divider.js';
import { useTranslation } from 'react-i18next';

function MutliStore(_a) {
    var classes = _a.classes, stores = _a.stores, onStoreSelected = _a.onStoreSelected;
    var t = useTranslation().t;
    var handleOnClick = function (id) {
        onStoreSelected && onStoreSelected(id);
    };
    var getStoreDistance = function (distance) {
        return distance < 100 ? distance === null || distance === void 0 ? void 0 : distance.toFixed(2) : distance === null || distance === void 0 ? void 0 : distance.toFixed(0);
    };
    return (React__default.createElement("div", { className: classNames('multi-store', classes) }, stores === null || stores === void 0 ? void 0 : stores.map(function (store) { return (React__default.createElement(React__default.Fragment, { key: store.id },
        React__default.createElement("div", { className: classNames('store-card'), onClick: function () { return handleOnClick(store.id); } },
            React__default.createElement("div", { className: "store-card-box" },
                React__default.createElement(Typography, { classes: "store-name", variant: "bodyTextOne", weight: "semibold" }, store.name),
                React__default.createElement(Typography, { classes: "store-address", variant: "bodyTextOne" }, store.address)),
            React__default.createElement(Typography, { noWrap: true, classes: "store-distance", variant: "bodyTextOne" },
                getStoreDistance(store.delivery_distance),
                " ",
                t('common.km'))),
        React__default.createElement(Divider, { variant: "horizontal", size: '100%', color: "#EDEDED", dividerStyle: 'solid', thickness: "thin" }))); })));
}

export { MutliStore as default };
//# sourceMappingURL=MutliStore.js.map
